// import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

function Cijfer({ image, aantal, description })
{
  return (
    <div className="flex flex-col relative text-center">
      <div className="w-36 h-36 mx-auto">
        <img src={image.url} alt={description} width="150px" height="150px" />
        {/* <GatsbyImage image={getImage(image)} alt={description} /> */}
      </div>
      <span className="text-orange font-bold text-4xl">{aantal}</span>
      <span className="text-blue font-medium text-3xl">{description}</span>
    </div>
  );
}

export default Cijfer;